// Used a separate file for bundling
export function isTextValuePanelSupported(
	zone: eXpress.core.IZone | undefined,
	definition: eXpress.core.IDefinition | null | undefined,
	dashboard: eXpress.TextZoneDashboard,
) {
	if (zone) return dashboard.canSetTextValue(zone);
	if (!definition) return false;
	return definition.textZones().some((textZone) => dashboard.canSetTextValue(textZone));
}
